declare const workspaceIdBrand: unique symbol;

export type WorkspaceId = string & { readonly [workspaceIdBrand]: never };

export function asWorkspaceId(id: string): WorkspaceId {
	return id as WorkspaceId;
}

export function asWorkspaceIds(ids: readonly string[]): WorkspaceId[] {
	return ids.map((id) => asWorkspaceId(id));
}

export type WithWorkspaceIds<T> = T extends unknown
	? Omit<T, 'workspaceIds'> & { workspaceIds: WorkspaceId[] }
	: never;

export function withWorkspaceIds<T extends { workspaceIds?: readonly string[] | null }>(
	value: T
): WithWorkspaceIds<T>;
export function withWorkspaceIds<T extends { workspaceIds?: readonly string[] | null }>(
	value: T
) {
	return {
		...value,
		workspaceIds: asWorkspaceIds(value.workspaceIds ?? []),
	};
}
